import PropTypes from "prop-types"
import styled from "styled-components"
import { whiteTheme, brandTertiaryTrans10Theme } from "../../theme"

const Header = styled.header`
  display: flex;
  /* background: linear-gradient(271.57deg, #74C04F 5.98%, #57AC2D 87.73%); */
  background: ${({ tint }) => (tint ? tint : whiteTheme)};
  width: 100%;
  align-items: center;
  flex-direction: column;
  clip-path: ${({ clipPath }) =>
    clipPath
      ? clipPath
      : "polygon(100% 0, 100% calc(100% - 6vw), 51% 100%, 0 calc(100% - 6vw), 0 0)"};

  &.padding-left-10,
  .padding-left-10 {
    padding-left: 10px;
  }
  .payment-billing-btn {
    margin-bottom: 60px !important;
  }
  ${({ theme }) => theme.se`
    padding: 90px 20px;
    &.mobile-app-header{
      padding: 90px 20px 35px;
    }
  `}

  ${({ theme }) => theme.tablet`
    padding: 50px 20px;
  `}

  ${({ theme }) => theme.desktop`
    padding: 60px 20px;
  `}

  ${({ theme }) => theme.largeDesktop`
    padding: 80px 0px;
  `}
`

Header.propTypes = {
  tint: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

Header.defaultProps = {
  tint: false,
}

export default Header
